import { handleDragStart, handleDrop, handleDragEnter, handleDragLeave, handleDragEnd, handleDragOver } from '../drag-and-drop';

interface IAskFor {
  askForId: number,
  askForText: string,
  validate: number,
  sequence: number,
  cardGroupId: number
}

/**
 * Function to display Ask For Questions widgets
 * 
 * @param {object} data Ask For Question data
 * @param {HTMLElement} container container for the selected item
 */
export const askForWidget = (data: any, container: HTMLElement) => {  
  data.forEach((value: IAskFor) => {
    let div = document.createElement('div');
    div.className = `askfor-widget aafp_askfor-box key_${value.askForId}`;
    div.setAttribute('draggable', 'true');
    div.addEventListener('dragstart', e => handleDragStart(e), false);
    div.addEventListener('dragenter', e => handleDragEnter(e), false);
    div.addEventListener('dragleave', e => handleDragLeave(e), false);
    div.addEventListener('dragover', e => handleDragOver(e), false);
    div.addEventListener('dragend', e => handleDragEnd(e), false);
    div.addEventListener('drop', e => handleDrop(e), false);

    let span = document.createElement('span');
    span.className = 'title';
    span.setAttribute('data-sequence', String(value.sequence));
    span.textContent = value.askForText;

    let innerdiv = document.createElement('div');
    innerdiv.className = 'askfor-widget-inner';

    let odometer = /^[Odometer]+$/;
    if(!odometer.test(value.askForText)) {
      let validate = document.createElement('a');
      validate.className = `aafp_user-form-button get-validate-element btn_color-theme${value.validate === 1 ? '-green' : ''}`;
      validate.innerText = value.validate === 1 ? 'Edit Validation' : 'Add Validation';
      validate.href = `/card-group/ask-for-questions/ask-for-questions-validation?askforid=${value.askForId}&cardgroup=${value.cardGroupId}&isvalidated=${value.validate}`;
      validate.setAttribute('data-askforid', String(value.askForId));
      validate.setAttribute('data-cardgroup', String(value.cardGroupId));
      validate.setAttribute('data-isvalidated', String(value.validate))
      innerdiv.appendChild(validate);
    }

    let driver = /^[Driver Number]+$/;
    if (!driver.test(value.askForText)) {
      let remove = document.createElement('a');
      remove.className = `aafp_user-form-button get-selected-element btn_color-theme-red`;
      remove.innerText = 'Remove';
      remove.setAttribute('data-askforid', String(value.askForId));
      remove.setAttribute('data-askfortext', value.askForText);
      remove.setAttribute('data-cardgroup', String(value.cardGroupId));
      innerdiv.appendChild(remove);
    }

    div.appendChild(span);
    div.appendChild(innerdiv);
    container.appendChild(div);
  });
}

interface IAvailAskFor {
  askForId: number,
  askForText: string,
  group: number
}

/**
 * Function to display Available Ask For questions
 */
export const askForAvailWidget = (data: any, container: HTMLElement) => {
  data.forEach((value: IAvailAskFor) => {
    let div = document.createElement('div');
    div.className = `askfor-widget aafp_askfor-box key_${value.askForId}`;

    let span = document.createElement('span');
    span.className = 'title';
    span.textContent = value.askForText;

    let innerdiv = document.createElement('div');
    innerdiv.className = 'askfor-widget-inner';

    let add = document.createElement('a');
    add.className = `aafp_user-form-button get-add-element btn_color-theme`;
    add.innerText = 'Add Question';
    add.setAttribute('data-askforid', String(value.askForId));
    add.setAttribute('data-askfortext', value.askForText);
    add.setAttribute('data-cardgroup', String(value.group));

    innerdiv.appendChild(add);
    div.appendChild(span);
    div.appendChild(innerdiv);
    container.appendChild(div);
  });
}